import { Button, Stack, styled } from "@mui/material";
import { BurgerMenu, LanguagePicker, ProfileButton as ProfileButtonsDropdown, WidthContainer } from "components/shared";
import { themeColors } from "constants/colors.const";
import { AppRoutes } from "enums/routes.enum";
import { useRef } from "react";
import { useDeviceDetect, useHeaderLogic } from "hooks";
import { useAppData, useUserStore } from "providers/RootStoreProvider";
import { Link } from "react-router-dom";
import { NavMenuNonLegal } from "./NavMenuNonLegal";
import { NonLegalMenuContent } from "./NonLegalMenuContent";
import { ReactComponent as CloseIcon } from "assets/icons/close-lightgrey.svg";
import { ReactComponent as LogoWhiteIcon } from "assets/icons/logo-white.svg";
import { UpButton } from "./UpButton";
import { LogInButton, ProfileButton } from "./AccountButtons";

const StyledHeaderNonLegal = styled("header")(() => ({
    position: "fixed",
    top: "0",
    left: "0",
    width: "100%",
    background: themeColors.text.fullBlack,
    "& *": {
        flexShrink: 0,
    },
}));

export const HeaderNonLegal = () => {
    const { isTablet } = useDeviceDetect();
    const { user } = useUserStore();
    const { flowOuter } = useAppData();

    const isLoggedIn = !!user?.email;

    const languagePickerRef = useRef<HTMLDivElement | null>(null);
    const sidebarRef = useRef<HTMLDivElement | null>(null);
    const sidebarTogglerRef = useRef<HTMLButtonElement | null>(null);

    const { handleCloseButtonClick, toggleSidebar, handleLogoClick, sidebar, isCloseButtonShown, isMenuTogglerShown, renderLoginButton, renderNavMenu } =
        useHeaderLogic({
            sidebarRef,
            sidebarTogglerRef,
            languagePickerRef,
        });

    return (
        <>
            <StyledHeaderNonLegal style={{ zIndex: 10, padding: isTablet ? "10px 0" : "10px 0" }}>
                <WidthContainer>
                    <Stack direction="row" justifyContent="space-between">
                        <Link
                            to={isLoggedIn ? AppRoutes.ACCOUNT : AppRoutes.HOME}
                            onClick={handleLogoClick}
                            style={{
                                padding: "2px 10px",
                                borderRadius: "16px",
                                boxSizing: "border-box",
                                height: "44px",
                                marginLeft: "-10px",
                            }}
                        >
                            <LogoWhiteIcon />
                        </Link>
                        {renderNavMenu && <NavMenuNonLegal />}
                        <Stack gap="12px" direction="row" justifyContent="flex-end" ref={languagePickerRef}>
                            {flowOuter && !isTablet && <LanguagePicker />}
                            {renderLoginButton && <ProfileButtonsDropdown>{isLoggedIn ? <ProfileButton /> : <LogInButton />}</ProfileButtonsDropdown>}
                            {isMenuTogglerShown && (
                                <BurgerMenu open={sidebar.isOpen} onClose={toggleSidebar} sx={{ "& .MuiPaper-root": { paddingTop: "80px" } }}>
                                    <NonLegalMenuContent onClose={toggleSidebar} />
                                </BurgerMenu>
                            )}
                            {isCloseButtonShown && (
                                <Button
                                    style={{
                                        padding: 0,
                                        width: "44px",
                                        height: "44px",
                                        borderRadius: "10px",
                                        whiteSpace: "nowrap",
                                        minWidth: "44px",
                                        border: `1px solid ${themeColors.brandColors.brandGreen}`,
                                    }}
                                    onClick={handleCloseButtonClick}
                                >
                                    <CloseIcon />
                                </Button>
                            )}
                        </Stack>
                    </Stack>
                </WidthContainer>
            </StyledHeaderNonLegal>
            <UpButton />
        </>
    );
};
